import { z } from 'zod'
import { AsyncFn } from '../../../common'
import { guidSchema } from '../../../contracts/_common'
import { CompanySimpleTimeWindowDtoRequest, ForCompany, ForCompanyUser } from '../../Company/Company'
import { bzOptional, Guid, ReferenceNumberContainer } from '../../common-schemas'
import { optionalEmailAddressValueSchema } from '../../Email/EmailTypes'
import { ForUser, UserGuidContainer } from '../../Users/User'

/** @deprecated */
export enum EstimateStatus {
  CREATED = 'CREATED',
  PRESENTED = 'PRESENTED',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  DELETED = 'DELETED',
}

export const EstimateStatusDisplayNames = {
  [EstimateStatus.CREATED]: 'Created',
  [EstimateStatus.PRESENTED]: 'Presented',
  [EstimateStatus.ACCEPTED]: 'Accepted',
  [EstimateStatus.REJECTED]: 'Rejected',
  [EstimateStatus.DELETED]: 'Deleted',
}

export const EstimateEntityTypeName = 'Estimate'

export type EstimateGuid = Guid
export type EstimateGuidContainer = {
  readonly estimateGuid: EstimateGuid
}

export const estimateGuidContainerSchema = z.object({
  estimateGuid: guidSchema,
})

export const estimateDuplicateForAccountSchema = estimateGuidContainerSchema.extend({
  accountGuid: guidSchema,
  jobGuid: guidSchema,
})

export type EstimateDuplicateForAccount = EstimateGuidContainer & {
  accountGuid: string
  jobGuid: string
}

export const estimateAndCompanyGuidContainerSchema = z.object({
  companyGuid: guidSchema,
  estimateGuid: guidSchema,
})

export const markEstimateAcceptedRequestSchema = z.object({
  companyGuid: guidSchema,
  estimateGuid: guidSchema,
  accountGuid: guidSchema,
  base64EstimateSignaturePng: z.string(),
})

export type AcceptEstimateInput = ForUser<{
  base64EstimateSignaturePng: string
}>

export type DeleteEstimateInput = ForCompany<UserGuidContainer>

export type MarkEstimateAcceptedRequest = z.infer<typeof markEstimateAcceptedRequestSchema>

// V2 PDF Blob Email Types
export const sendEstimatePdfBlobRequestSchema = z.object({
  estimateGuid: guidSchema,
  to: optionalEmailAddressValueSchema,
  subject: z.string(),
  description: z.string(),
  pdfBlob: z.string(), // base64 encoded PDF
  filename: z.string(),
})

export type SendEstimatePdfBlobRequest = z.infer<typeof sendEstimatePdfBlobRequestSchema>

export type EstimatePdfBlobEmailer = AsyncFn<ForCompanyUser<SendEstimatePdfBlobRequest>, void>

export const sendEstimateReviewLinkRequestSchema = z.object({
  estimateGuid: guidSchema,
  deliveryMethod: z.enum(['EMAIL', 'SMS']),
  customMessage: bzOptional(z.string()),
  overrideTo: bzOptional(z.string()),
})
export type SendEstimateReviewLinkRequest = z.infer<typeof sendEstimateReviewLinkRequestSchema>

export type EstimatesNotDeletedRequest = {
  query: 'for-estimates-not-deleted'
} & CompanySimpleTimeWindowDtoRequest

export type EstimatesRequest = EstimatesNotDeletedRequest

export type EstimateDuplicateForAccountInput = ForUser<
  ReferenceNumberContainer & {
    accountGuid: string
    jobGuid: string
  }
>
